import React from "react"
import { getClasses } from "../../js/classUtils";
import "./Description.css"

function Description({title, children, centered}){

    const descriptionClasses = getClasses({
        "description" : true,
        "description--centered": centered
    });

    return(
        <article className={descriptionClasses}>
            <h1 className="description__title">{title}</h1>
            <p className="description__text">{children}</p>
        </article>
    )
}

export default Description;